import { useMemo } from 'react';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  Business as BusinessIcon,
  DriveEta as DriveEtaIcon,
  Home as HomeIcon,
  Room as RoomIcon,
} from '@material-ui/icons';

type OrderDeliveryTypeChipProps = {
  deliveryType: string;
  size?: 'small' | 'medium';
};

const useStyles = makeStyles(() => ({
  root: (props: { backgroundColor: string; color: string }) => ({
    borderRadius: 4,
    textTransform: 'capitalize',
    backgroundColor: props.backgroundColor,
    color: props.color,

    '& .MuiChip-label': {
      display: 'flex',
      alignItems: 'center',
      gap: 6,

      '& > svg': {
        width: 16,
        height: 16,
        fill: props.color,
      },

      '& > span': {
        fontSize: 12,
        lineHeight: '14px',
      },
    },
  }),
}));

const getChipStyle = (
  deliveryType: string
): { backgroundColor: string; color: string; icon: React.ReactElement; label: string } => {
  switch (deliveryType) {
    case 'organization':
      return { backgroundColor: '#2196f3', color: '#ffffff', icon: <BusinessIcon />, label: 'Organisation' };
    case 'relay':
    case 'relayPoint':
      return { backgroundColor: '#ff9800', color: '#ffffff', icon: <RoomIcon />, label: 'Point relais' };
    case 'home':
      return { backgroundColor: '#8e44ad', color: '#ffffff', icon: <HomeIcon />, label: 'Domicile' };
    case 'drive':
      return { backgroundColor: '#607d8b', color: '#ffffff', icon: <DriveEtaIcon />, label: 'Drive' };
    default:
      return { backgroundColor: '#e0e0e0', color: '#424242', icon: <RoomIcon />, label: deliveryType };
  }
};

export default function OrderDeliveryTypeChip({ deliveryType, size = 'small' }: OrderDeliveryTypeChipProps) {
  const { label, backgroundColor, color, icon } = useMemo(() => getChipStyle(deliveryType), [deliveryType]);

  const classes = useStyles({ backgroundColor, color });

  return (
    <Chip
      className={classes.root}
      size={size}
      label={
        <>
          {icon}
          <span>{label}</span>
        </>
      }
    />
  );
}
